<template>
  <div class="status-class-info-distribute"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="distributeInfo">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <el-form size="mini"
                 label-position="top"
                 label-suffix="：">
          <el-form-item>
            <template #label>
              <span>分配情况<span class="theme-text">（显示红色的账号为无效状态，教学点班主任不允许在此做调整）</span></span>
            </template>
            <el-transfer v-model="distributes"
                         :data="distributeInfo.classTeachers"
                         filterable
                         :titles="['可选班主任', '已选班主任']"
                         :props="defaultProps">
              <template #default="{option}">
                <div class="custom-distribute-item"
                     :class="{'invalid': option.invalid}"
                     :title="option.name">
                  <div class="name">
                    <span v-if="option.generic">[教学点]</span>
                    <span>{{option.name}}</span>
                  </div>
                </div>
              </template>
            </el-transfer>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交保存</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>班主任数据加载失败</div>
        <el-button type="text"
                   @click="loadDistributeInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'StatusClassInfoDistribute',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      distributeInfo: null,
      distributes: [],
      defaultProps: {
        key: 'id',
        label: 'name',
        disabled: 'generic'
      },
      committing: false
    }
  },
  methods: {
    loadDistributeInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/clazz/info/distributeInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.distributeInfo = response.data['distributeInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      let distributes = this.distributes || []
      let originDistributes = this.distributeInfo ? (this.distributeInfo.distributes || []) : []
      let addDistributes = []
      let delDistributes = []
      distributes.forEach(id => {
        if (!originDistributes.includes(id)) {
          addDistributes.push(id)
        }
      })
      originDistributes.forEach(id => {
        if (!distributes.includes(id)) {
          delDistributes.push(id)
        }
      })
      if (addDistributes.length === 0 && delDistributes.length === 0) {
        this.$message.warning('配置未发生变化')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/status/clazz/info/submitDistribute',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id,
          addDistributes: addDistributes,
          delDistributes: delDistributes
        }, this.extraParams), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadDistributeInfo()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.loadDistributeInfo()
      }
    },
    distributeInfo: function (val) {
      if (val) {
        this.distributes = val.distributes || []
      } else {
        this.distributes = []
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .status-class-info-distribute {
    min-height: 300px;
    & > .main-cont {
      min-height: 300px;
      padding: 10px 20px;
      box-sizing: border-box;
      .el-form {
        .el-form-item {
          margin-bottom: 10px;
          .el-form-item__label {
            font-size: 12px;
            padding-bottom: 2px;
          }
          .el-form-item__content {
            font-size: 12px;
            .el-checkbox-group {
              .el-checkbox {
                display: block;
                .el-checkbox__label {
                  font-size: 12px;
                }
              }
            }
            .el-transfer {
              display: flex;
              align-items: center;
              font-size: 12px;
              & > .el-transfer-panel {
                flex: 0 1 50%;
                width: auto;
                border-radius: 0;
                .el-transfer-panel__header {
                  .el-checkbox {
                    .el-checkbox__label {
                      font-size: 13px;
                    }
                  }
                }
                .el-transfer-panel__body {
                  height: 320px;
                  .el-transfer-panel__list {
                    height: 320px;
                    &.is-filterable {
                      height: 273px;
                    }
                  }
                  .el-checkbox {
                    margin-right: 15px;
                    .el-checkbox__label {
                      font-size: 12px;
                      .custom-distribute-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        & > .name {
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        }
                        &.invalid {
                          color: $set-danger-color;
                        }
                      }
                    }
                    &.is-disabled {
                      .el-checkbox__label {
                        color: #909399;
                      }
                    }
                  }
                }
              }
              & > .el-transfer__buttons {
                padding-left: 10px;
                padding-right: 10px;
                white-space: nowrap;
                .el-button {
                  padding: 4px;
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
    .layout-hint {
      height: 300px;
    }
  }
</style>
